import React from 'react';
import FormWidget from './new-widget';

import useAppContext from '../../../../context/useAppContext';
import { useParams, useHistory } from 'react-router-dom';

import { useTranslation } from 'react-i18next';
import { ToastContext } from '@weezevent/nacre';

import Widget from '../../../../models/widget';

import Loading from '../../../../components/loading';

export default function EditWidget() {
    const [{ organization }] = useAppContext();
    const { widget_id } = useParams();
    const { t } = useTranslation();

    const history = useHistory();
    const toast = React.useContext(ToastContext);

    const [widget, loading] = Widget.useApiModel({
        organizationId: organization.pk,
        id: widget_id,
        query: {
            expand: 'widget_events.event'
        },
        onError: e => {
            if (e.code === 404) {
                toast.error(t('pageNotFound'));
            } else {
                toast.error(t('ticket.common.unknown_error'));
            }

            history.push(`/ticket/O${organization.id}/widgets`);
        }
    });

    if (loading) {
        return <Loading />;
    }

    return <FormWidget widget={widget} />;
}
